import React from "react";
import Button from "@mui/material/Button";
import DownloadIcon from "@mui/icons-material/Download";

function toCSV(rows, columns) {
  const header = columns.map((c) => JSON.stringify(c.label)).join(",");
  const lines = rows.map((row) =>
    columns.map((c) => {
      const val = c.value(row);
      if (val === null || val === undefined) return "";
      if (typeof val === "number") return val;
      return JSON.stringify(String(val));
    }).join(",")
  );
  return [header, ...lines].join("\n");
}

export default function ExportButton({ rows, columns, filename = "export.csv", disabled }) {
  function handleExport() {
    const csv = toCSV(rows, columns);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  }

  return (
    <Button
      size="small"
      variant="outlined"
      startIcon={<DownloadIcon fontSize="small" />}
      onClick={handleExport}
      disabled={disabled || !rows || rows.length === 0}
    >
      Export CSV
    </Button>
  );
}
